import { Typography } from "PFComponents/typography";
import { minutesToHours } from "PFCore/helpers/date";
import { useTranslation } from "react-i18next";

type DurationAttributeProps = {
  value: number;
};

export const DurationAttribute = ({ value }: DurationAttributeProps) => {
  const { t } = useTranslation("bookingModule");
  const hoursValue = minutesToHours(value);
  return (
    <Typography withMargin variant="bodyRegular" tag="span">
      {t("details.history.hour", { count: hoursValue })}
    </Typography>
  );
};
